import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { ApolloResponse } from '@/interfaces/apollo'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { CertificateOfInsurance } from '@/modules/CertificateOfInsurance/interfaces/certificate-of-insurance'
import { showErrors } from '@/utils/snack'
import { dateTimeToDisplay, dateToNow } from '@/utils/dateTime'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import { Account } from '@/modules/Account/interfaces/account'
import AppSearch from '@/components/AppSearch.vue'
import AppRefresh from '@/components/AppRefresh.vue'
import AppTabs from '@/components/AppTabs.vue'
import CertificateOfInsuranceDialog from '@/modules/CertificateOfInsurance/scripts/certificate-dialog'
import { Policy } from '@/modules/Policy/interfaces/policy'

import CertificateOfInsuranceDetailDetail from '@/modules/CertificateOfInsurance/views/detail.vue'
import { getCertificateOfInsurance } from '@/modules/CertificateOfInsurance/gql/certificate.gql'

@Component({
  components: {
    AppBreadcrumbs,
    AppSearch,
    AppRefresh,
    AppTabs,
    CertificateOfInsuranceDetailDetail
  }
})
export default class CertificateOfInsuranceDetail extends mixins(CertificateOfInsuranceDialog) {
  breadcrumbs: Breadcrumb[] = []

  certificateName = ''

  certificate: CertificateOfInsurance | null = null

  windowSize = {
    w: 0,
    h: 0,
    cW: 0
  }

  tabActive = 0
  tabItems = [
    { title: 'Details', route: 'CertificateOfInsuranceDetailDetail' },
    { title: 'Acord Forms', route: 'CertificateOfInsuranceDetailAcord' }
  ]
  account: Account | null = null

  dateTimeToDisplay = dateTimeToDisplay
  dateToNow = dateToNow

  get tabTitles () {
    return this.tabItems.map(item => item.title)
  }

  async mounted () {
    const { name, params } = this.$route
    const index = this.$R.findIndex((item: any) => item.route === name)(this.tabItems)
    this.tabActive = index
    this.onResize()
    this.getCertificateOfInsurance()
  }

  @Watch('$route.params.id')
  onRouteParamUpdate (val: string) {
    this.getCertificateOfInsurance()
  }

  onResize () {
    const container = this.$refs.container as Vue & { clientWidth: number }
    this.windowSize = { w: window.innerWidth, h: window.innerHeight, cW: container.clientWidth }
  }

  clickTabHandler (index: number) {
    const item = this.tabItems[index]
    if (item.route && item.route !== this.$route.name) {
      this.$router.push({
        name: item.route
      })
    }
  }

  async getCertificateOfInsurance () {
    const coiId = Number(this.$route.params.id)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCertificateOfInsurance,
        variables: {
          coiId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.certificate = result.data.getCertificateOfInsurance as CertificateOfInsurance

      this.breadcrumbs = [
        {
          text: 'Client Information'
        },
        {
          text: this.certificate.account.name,
          to: {
            name: 'AccountDetailCertificate',
            params: {
              id: this.certificate.account.id
            }
          }
        },
        {
          text: 'COI'
        },
        {
          text: this.certificate.coi
        }
      ]
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async deleteCertificateConfirm () {
    await this.deleteCertificatePost()
    this.$router.replace({
      name: 'AccountDetailCertificate',
      params: {
        id: this.$route.params.accountId
      }
    })
  }

  routeToPolicyDetail (policy: Policy) {
    this.$router.push({
      name: 'PolicyDetailDetail',
      params: {
        id: policy.id + ''
      }
    })
  }

  clearForm () {
    this.hideCertificateEditDialog()
  }

  onFormSuccess () {
    this.getCertificateOfInsurance()
  }
}
